import {SiteFiltersType} from "../../commons/types/site-filters.type";
import {ServiceStatusType} from "../../deliveries/types/service-status.type";
import * as _ from "lodash";

export const getServicesFiltersInitialization = (panelServicesFilters: any, defaultRange: any) => {
  return {
    includeFilters: [
      SiteFiltersType.dateRangeTemplateType,
      SiteFiltersType.serviceTypes,
      SiteFiltersType.branchIds,
      SiteFiltersType.accountIds,
      SiteFiltersType.serviceAreaIds,
      SiteFiltersType.noArea,
      SiteFiltersType.serviceAreaPickup,
      SiteFiltersType.serviceAreaDropoff,
      SiteFiltersType.depotIds,
      SiteFiltersType.supplyAccountIds,
      SiteFiltersType.teamIds,
      SiteFiltersType.agentIds,
      SiteFiltersType.labels,
      SiteFiltersType.tags,
      SiteFiltersType.vehicleTypeIds,
      SiteFiltersType.riskTypes,
      SiteFiltersType.programTypes,
      SiteFiltersType.isPacked,
      SiteFiltersType.inRoute,
      SiteFiltersType.timeToDeliver,
      SiteFiltersType.approvalStatuses,
      SiteFiltersType.dispatchQuoteTypes,
      SiteFiltersType.isMissingPackages,
      SiteFiltersType.packagesIds,
      SiteFiltersType.configuredPackageField,
      SiteFiltersType.configuredFieldName,
      SiteFiltersType.configuredFieldValue,
      SiteFiltersType.reasonType,
      SiteFiltersType.agentType
    ],
    bringozFilters: {
      [SiteFiltersType.dateRangeTemplateType]: undefined,
      [SiteFiltersType.serviceStatusGroup]: ServiceStatusType.Unassigned,
      [SiteFiltersType.serviceTypes]: [],
      [SiteFiltersType.branchIds]: [],
      [SiteFiltersType.agentBranchIds]: [],
      [SiteFiltersType.accountIds]: [],
      [SiteFiltersType.serviceAreaIds]: [],
      [SiteFiltersType.depotIds]: [],
      [SiteFiltersType.supplyAccountIds]: [],
      [SiteFiltersType.teamIds]: [],
      [SiteFiltersType.agentIds]: [],
      [SiteFiltersType.labels]: [],
      [SiteFiltersType.tags]: [],
      [SiteFiltersType.vehicleTypeIds]: [],
      [SiteFiltersType.riskTypes]: [],
      [SiteFiltersType.programTypes]: [],
      [SiteFiltersType.inRoute]: _.get(panelServicesFilters?.bringozFilters, SiteFiltersType.inRoute),
      [SiteFiltersType.isPacked]: undefined,
      [SiteFiltersType.dispatchQuoteTypes]: [],
      [SiteFiltersType.timeToDeliver]: undefined,
      [SiteFiltersType.approvalStatuses]: [],
      [SiteFiltersType.noArea]: undefined,
      [SiteFiltersType.noPickUpArea]: undefined,
      [SiteFiltersType.noDropOffArea]: undefined,
      [SiteFiltersType.isMissingPackages]: undefined,
      [SiteFiltersType.packagesIds]: [],
      [SiteFiltersType.configuredFieldName]: undefined,
      [SiteFiltersType.configuredFieldValue]: undefined,
      [SiteFiltersType.reasonType]: [],
      [SiteFiltersType.agentType]: undefined
    },
    range: panelServicesFilters?.range || defaultRange,
    queryString: undefined
  };
};
